import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from 'axios';
import {RootState} from '../rootReducer'
import { IDepartment, Department } from '../../models/departments';

const api = process.env.REACT_APP_API_URL
const initialState: IDepartment = {
    departments:[{id:0,name:''}],
    loading:false
}

// APIs para consumir

//  Para listar los departamentos y posteriormente usarlo con Redux
export const departmentList = createAsyncThunk<IDepartment,
    { token: string },
    {
        rejectValue: string
    }>(
    'department/list',
    async ({token}, thunkApi) => {
        try {
            const response = await axios.get(`${api}/listDepartments`, {
                headers: {
                    Authorization: `Bearer ${token}` // Incluye el token en las cabeceras
                }
            });
            return response.data;
        } catch (err) {
            console.error("Error fetching departments:", err);
            return thunkApi.rejectWithValue('error')
        }
    }
)

//  Slices
export const departmentSlice = createSlice({
    initialState,
    name: 'department',
    extraReducers: builder => {
        builder
            .addCase(departmentList.pending, state => {
                state.loading = true
            })
            .addCase(departmentList.fulfilled, (state, {payload}) => {
                // @ts-ignore
                //state.departments = payload
                state.departments = payload.data.sort((a, b) =>
                    a.name.localeCompare(b.name)
                );
                state.loading = false
            })
            .addCase(departmentList.rejected, (state, action) => {
                state.loading = true
            })
    },
    reducers: {},
})

export const DepartmentReducer = departmentSlice.reducer
export const DepartmentSelector = (state: RootState) => state.departments
